export default __webpack_public_path__ + "static/cert-1-img-3df9788dae1afadff3bf6ebbb23448bd.png";